import {
  BulkMessagePermissionSet,
  FareRulePermissionSet,
  FleetPermissionSet,
  GroupPermissionSet,
  NotificationSettingPermissionSet,
  PermissionSetType,
  RequestPermissionSet,
  RiderDriverRestrictionPermissionSet,
  RiderOnboardingFlowPermissionSet,
  ServicePermissionSet,
  SidebarProductVisibilityPermissionSet,
  TimeRulePermissionSet,
  TipPermissionSet,
  VehiclePermissionSet,
} from '../sets'
import { AdminMinimalRole } from './AdminMinimalRole'

export const ServicePlannerRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowOperationsProduct,

  ServicePermissionSet.View,
  ServicePermissionSet.Share,
  ServicePermissionSet.Write,
  ServicePermissionSet.Delete,
  ServicePermissionSet.WriteRoute,
  ServicePermissionSet.Import,

  RiderDriverRestrictionPermissionSet.View,
  RiderDriverRestrictionPermissionSet.Create,
  RiderDriverRestrictionPermissionSet.Delete,
  FareRulePermissionSet.View,
  FareRulePermissionSet.Write,
  FareRulePermissionSet.Delete,

  FleetPermissionSet.View,
  FleetPermissionSet.New,
  FleetPermissionSet.Edit,
  TimeRulePermissionSet.View,
  TimeRulePermissionSet.New,
  TimeRulePermissionSet.Edit,
  TimeRulePermissionSet.Delete,
  TipPermissionSet.ViewPolicy,
  TipPermissionSet.WritePolicy,
  TipPermissionSet.DeletePolicy,

  GroupPermissionSet.View,
  GroupPermissionSet.Write,
  GroupPermissionSet.WriteCondition,
  GroupPermissionSet.ViewCondition,

  NotificationSettingPermissionSet.View,
  NotificationSettingPermissionSet.Write,

  BulkMessagePermissionSet.View,
  BulkMessagePermissionSet.Write,

  VehiclePermissionSet.View,

  RequestPermissionSet.ViewDailyCounts,

  RiderOnboardingFlowPermissionSet.View,
]
